import React, { useState ,useEffect} from "react";
import {
  Table,
  Tag,
  Progress,
  Button,
  Modal,
  Input,
  Checkbox,
  Form,
  InputNumber,
  message,
} from "antd";
import Layout from "Layout";
import { mixGetV1, mixPostV1,mixPutV1,mixDelV1  } from "services/mixin";

const DvChatTable: React.FC = () => {
  const [visibleTokens, setVisibleTokens] = useState<{ [key: number]: boolean }>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState<any>(null);
  const [form] = Form.useForm();
    const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);
 const fetchData = async () => {
    setLoading(true);
    try {
      const res = await mixGetV1("/api/v1/be/model_chat_categories");
      if (res.status && res.data?.items) {
        const items = res.data.items.map((item: any) => ({
          key: item.id,
          name: item.name,
          // token: item.api_token || "Chưa có token",
          // usage: item.usage || 0,
          // max: item.token_limit || 0,
          // percent:
          //   item.token_limit && item.usage
          //     ? Math.round((item.usage / item.token_limit) * 100)
          //     : 0,
          status: item.is_active === 1,
          date: new Date(item.created_at).toLocaleDateString("vi-VN"),
        }));
        setData(items);
      } else {
        message.warning("Không có dữ liệu hiển thị!");
      }
    } catch (err) {
      console.error(err);
      message.error("Lỗi khi tải danh sách dịch vụ!");
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = async (record) => {
    Modal.confirm({
      title: "Xóa dịch vụ này?",
      content: record.name,
      okText: "Xóa",
      okType: "danger",
      cancelText: "Hủy",
      onOk: async () => {
        try {
          await mixDelV1(`/api/v1/be/model_chat_category/${record.key}`);
          message.success("Xóa thành công!");
          fetchData(); // refresh lại danh sách
        } catch (error) {
          console.error(error);
          message.error("Xóa thất bại!");
        }
      },
    });
  };



  // const [data, setData] = useState([
  //   {
  //     key: 1,
  //     name: "OpenAI GPT-4",
  //     token: "sk-ant-api03-xyz789abc456d9",
  //     usage: 347850,
  //     max: 1000000,
  //     percent: 35,
  //     status: true,
  //     date: "10/19/2025",
  //   },
  //   {
  //     key: 2,
  //     name: "OpenAI GPT-3.5 Turbo",
  //     token: "sk-ant-api03-xyz789abc456d",
  //     usage: 128945,
  //     max: 500000,
  //     percent: 26,
  //     status: true,
  //     date: "10/19/2025",
  //   },
  //   {
  //     key: 3,
  //     name: "Anthropic Claude",
  //     token: "sk-proj-abcdef1234567890ghijklmn",
  //     usage: 0,
  //     max: 750000,
  //     percent: 0,
  //     status: true,
  //     date: "10/19/2025",
  //   },
  // ]);

  // Toggle ẩn/hiện token
  const toggleToken = (key: number) => {
    setVisibleTokens((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // Mở modal thêm mới
  const openAddModal = () => {
    setEditingRecord(null);
    form.resetFields();
    form.setFieldsValue({
      is_active: true,
    });
    setIsModalOpen(true);
  };

  // Mở modal chỉnh sửa
  const openEditModal = (record: any) => {
    setEditingRecord(record);
    form.setFieldsValue({
    name: record.name,
    // api_token: record.token,
    // token_limit: record.max,
    is_active: record.status,
  });
    setIsModalOpen(true);
  };
  // Hàm tạo slug từ tên
  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "") // bỏ ký tự đặc biệt
      .replace(/\s+/g, "-"); // thay khoảng trắng bằng dấu gạch ngang
  };

  // Xử lý khi submit form
  const handleOk = async () => {
    const values = await form.validateFields();
    values.slug = generateSlug(values.name || "");
    try {
      if (editingRecord) {
        await mixPutV1(`/api/v1/be/model_chat_category/${editingRecord.key}`, values); // PUT/PATCH nếu backend hỗ trợ
        message.success("Cập nhật thành công!");
      } else {
        await mixPostV1("/api/v1/be/model_chat_category", values);
        message.success("Thêm mới thành công!");
      }
      setIsModalOpen(false);
      fetchData();
    } catch (error) {
      console.error(error);
      message.error("Lưu thất bại!");
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Cột bảng
  const columns = [
    {
      title: "Dịch vụ",
      dataIndex: "name",
      key: "name",
      render: (text: string, record: any) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              background: "#EAF1FF",
              padding: 6,
              borderRadius: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-message-square w-5 h-5 text-blue-600"
            >
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
          </div>
          <div>
            <div style={{ fontWeight: 600 }}>{text}</div>
            <div style={{ color: "#888", fontSize: 12 }}>{record.date}</div>
          </div>
        </div>
      ),
    },
    // {
    //   title: "API Token",
    //   dataIndex: "token",
    //   key: "token",
    //   render: (_: any, record: any) => {
    //     const isVisible = visibleTokens[record.key];
    //     const maskedToken = record.token.replace(/.(?=.{4})/g, "•");
    //     return (
    //       <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    //         <span style={{ fontFamily: "monospace"  , wordBreak: "break-all", 
    //         whiteSpace: "normal", 
    //         lineHeight: 1.4, }}>
    //           {isVisible ? record.token : maskedToken}
    //         </span>
    //         <svg
    //           onClick={() => toggleToken(record.key)}
    //           xmlns="http://www.w3.org/2000/svg"
    //           width="20"
    //           height="20"
    //           viewBox="0 0 24 24"
    //           fill="none"
    //           stroke="currentColor"
    //           strokeWidth="2"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //           style={{ cursor: "pointer" }}
    //         >
    //           {isVisible ? (
    //             <>
    //               <path d="M1 1l22 22" />
    //               <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20C7 20 2.73 16.11 1 12c.74-1.64 2.05-3.35 3.78-4.94" />
    //               <path d="M10.73 5.08A10.94 10.94 0 0 1 12 4c5 0 9.27 3.89 11 8-1.06 2.36-2.92 4.48-5.06 5.94" />
    //             </>
    //           ) : (
    //             <>
    //               <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z" />
    //               <circle cx="12" cy="12" r="3" />
    //             </>
    //           )}
    //         </svg>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   title: "Token Usage",
    //   key: "usage",
    //   render: (_: any, record: any) => (
    //     <div>
    //       <div>
    //         {record.usage.toLocaleString()} / {record.max.toLocaleString()}
    //       </div>
    //       <Progress
    //         percent={record.percent}
    //         showInfo={true}
    //         size="small"
    //         strokeColor="rgb(34 197 94)"
    //       />
    //     </div>
    //   ),
    // },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      render: (status: boolean) => (
        <Tag color={status ? "green" : "red"} style={{ fontWeight: 500 }}>
          {status ? "✓ Active" : "✗ Inactive"}
        </Tag>
      ),
    },
    {
      title: "Hành động",
      key: "action",
      render: (_: any, record: any) => (
        <div style={{ display: "flex", gap: 10 }}>
          <button
            style={{ color: "rgb(37 99 235)", background: "transparent", border: "none" }}
            onClick={() => openEditModal(record)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-square-pen w-4 h-4"
            >
              <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.375 2.625a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4Z"></path>
            </svg>
          </button>
          {/* <button style={{ color: "rgb(234 88 12)", background: "transparent", border: "none"}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-activity w-4 h-4"><path d="M22 12h-4l-3 9L9 3l-3 9H2"></path></svg>
          </button>
          <button><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-xcircle w-4 h-4"><circle cx="12" cy="12" r="10"></circle><path d="m15 9-6 6"></path><path d="m9 9 6 6"></path></svg></button> */}
          <button
            style={{ color: "rgb(220 38 38)", background: "transparent", border: "none" }}
            onClick={() => handleDelete(record)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-trash2 w-4 h-4"
            >
              <path d="M3 6h18"></path>
              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
              <line x1="10" x2="10" y1="11" y2="17"></line>
              <line x1="14" x2="14" y1="11" y2="17"></line>
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <Layout>
      <div style={{ padding: 20 }}>
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
          <Button type="primary" onClick={openAddModal}>
            + Thêm dịch vụ
          </Button>
        </div>

        <Table columns={columns} dataSource={data} pagination={false} bordered />

        <Modal
          title={
            <h1 style={{ fontWeight: 700 }}>
              {editingRecord ? "Edit " : "Add "}
            </h1>
          }
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
          centered
        >
          <Form form={form} layout="vertical">
            <Form.Item
              label=" Name"
              name="name"
              rules={[{  message: "Nhập tên dịch vụ!" }]}
            >
              <Input placeholder="OpenAI....." />
            </Form.Item>

            {/* <Form.Item
              label="API Token"
              name="api_token"
              rules={[{message: "Nhập token API!" }]}
            >
              <Input placeholder="sk-..." />
            </Form.Item>

            <Form.Item label="Token Limit (0 for unlimited)" name="token_limit">
              <InputNumber
                min={0}
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  border: "1px solid #d9d9d9",
                }}
              />
            </Form.Item> */}

            <Form.Item name="is_active" valuePropName="checked">
              <Checkbox>Active Service</Checkbox>
            </Form.Item>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <Button onClick={handleCancel}>Cancel</Button>
              <Button type="primary" onClick={handleOk}>
                {editingRecord ? "Update" : "Add"}
              </Button>
            </div>
          </Form>
        </Modal>
      </div>
    </Layout>
  );
};

export default DvChatTable;
